import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { connect, useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, ISC_INV_TRANSFER_URL, ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from '../../../components/hoc/Ax';
import tapIcon from '../../../services/TapIcon';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';

const InventoryTransferAddDocument = forwardRef( (props, ref)=> {
    const { inventoryData, getInventoryTransferDetail } = props;
    
    useImperativeHandle(ref, () => ({
        showModalInit() {
            showModalInit()
        }
    }));
    const access_token              = useSelector(state => state.auth.access_token ? state.auth.access_token : "")
    const modalId                   = useRef(uuid());
    const addDocModal               = useRef(null);
    const [loadForm, setLoadForm]                           = useState(false);
    const [documentSubmitting, setDocumentSubmitting]       = useState(false);
    const [other, setOther]                                 = useState('N');
    const [addDocumentForm, setAddDocumentForm]             = useState({
        name: "",
        number: "",
        file: null,
        file_name: null,
        base64_document: null
    });
    const [documentTypes, setDocumentTypes]                = useState([]);
    const [inventoryTransferDetail, setInventoryTransferDetail] = useState(null);
    

    const iscDocTypeUrl         =   `${ORG_API_BASE_URL_2}/setting/isc_doc_types`;
    const inventoryDocUrl       =   ISC_INV_TRANSFER_URL +  '/document' ;

    useEffect(() => {
        
        addDocModal.current = new Modal(document.getElementById(modalId.current), { keyboard: false, backdrop: false });
    }, []);

    const showModalInit = () => {

        addDocModal.current.show();
        setLoadForm(true);
        setDocumentSubmitting(false);
        setInventoryTransferDetail({ ...inventoryData });

        HttpAPICall.withAthorization('GET', iscDocTypeUrl, access_token, {}, {}, (response) => {
            setDocumentTypes(response.data.map(s => ({ value: s, label: s })));
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => setLoadForm(false));
    };

    const handleFileChange = async (e) => {
        let file = e.target.files[0];
        let filename = file.name;
        const base64 = await convertBase64(file);
        setAddDocumentForm(prevForm => ({ ...prevForm, base64_document: base64, file_name: filename }));
    };

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result.replace("data:", "").replace(/^.+,/, ""));
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const addInventoryDocument = (e) => {
        e.preventDefault();
        setDocumentSubmitting(true);
        const transaction_id = inventoryTransferDetail?.transaction_id;
        const frmData = {
                    name               :   addDocumentForm.name,
                    number             :   addDocumentForm.number,
                    file_name          :   addDocumentForm.file_name,
                    base64_document    :   addDocumentForm.base64_document,
                    transaction_id
        };

        HttpAPICall.withAthorization('POST', `${inventoryDocUrl}/add`, access_token, null, frmData, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            getInventoryTransferDetail(transaction_id);
            addDocModal.current.hide();
        }).then(() => setDocumentSubmitting(false));
    };

    return (
        <div className="modal fade" id={modalId.current} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addDocModalLabel">Add Document</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    {loadForm
                        ? <Loader />
                        : <Ax>
                            <form onSubmit={addInventoryDocument}>
                                <div className="modal-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-3">
                                            <label className="form-label require">Document Type</label>
                                        </div>
                                        <div className="col-sm-7">
                                            {other === "Y"
                                                ? <input
                                                    name="name"
                                                    type="text"
                                                    value={addDocumentForm.name}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => setAddDocumentForm({ ...addDocumentForm, name: e.target.value })}
                                                    placeholder="Please enter Type Name"
                                                    required={true}
                                                />
                                                : <TapSelect
                                                    options={documentTypes}
                                                    changeEvent={(selectedOption) => setAddDocumentForm({ ...addDocumentForm, name: selectedOption ? selectedOption.value : '' })}
                                                    value={documentTypes.find(u => addDocumentForm.name === u.value)}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    placeholder="Select Document Type"
                                                    autoComplete="off"
                                                    required={true}
                                                    autoFocus={true}
                                                />
                                            }
                                        </div>
                                        <div className="col-sm-2">
                                            <input
                                                name="other"
                                                type="checkbox"
                                                value={other}
                                                onChange={() =>  { 
                                                    setOther(other === 'N' ? 'Y' : 'N');
                                                    setAddDocumentForm(pre => ({...pre, name: '' }))
                                                }}
                                                checked={other === 'Y'}
                                                className="form-check-input"
                                                id="other"
                                            />
                                            <label className="form-check-label mx-2" htmlFor="other">New</label>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Document Number</label>
                                        </div>
                                        <div className="col-md-7">
                                            <input
                                                name="number"
                                                type="text"
                                                value={addDocumentForm.number}
                                                onChange={(e) => setAddDocumentForm({ ...addDocumentForm, number: e.target.value })}
                                                className="form-control"
                                                autoComplete="off"
                                                placeholder="Enter Document Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <label className="form-label require">Document</label>
                                        </div>
                                        <div className="col-md-7">
                                            <input
                                                name="file"
                                                type="file"
                                                onChange={(e) => {
                                                    handleFileChange(e);
                                                }}
                                                className="form-control"
                                                autoComplete="off"
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" disabled={documentSubmitting} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={documentSubmitting} className="btn btn-primary">Submit {documentSubmitting && <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />}</button>
                                </div>
                            </form>
                        </Ax>
                    }
                </div>
            </div>
        </div>
    );
});

export default InventoryTransferAddDocument;
